import { render, staticRenderFns } from "./Pmau.vue?vue&type=template&id=0a604a9c&scoped=true&"
import script from "./Pmau.vue?vue&type=script&lang=js&"
export * from "./Pmau.vue?vue&type=script&lang=js&"
import style0 from "./Pmau.vue?vue&type=style&index=0&id=0a604a9c&scoped=true&lang=css&"
import style1 from "./Pmau.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a604a9c",
  null
  
)

export default component.exports